import { render, staticRenderFns } from "./OperativeModel.vue?vue&type=template&id=67728f45"
import script from "./OperativeModel.vue?vue&type=script&lang=ts"
export * from "./OperativeModel.vue?vue&type=script&lang=ts"
import style0 from "./OperativeModel.vue?vue&type=style&index=0&id=67728f45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports